import ValidatedBanner from './ValidatedBanner';

export default ValidatedBanner;
